module.exports = __webpack_public_path__ + "media/images/matching-q-dd9f123ad6224658774fa1c67b57a8cf.png";